




























import { Vue, Prop, Component } from 'vue-property-decorator';
import { VbSnackbarService } from '@/shared/snackbar/snackbar.service';
import InvoicePaymentLinkService from '@/domain/billing/service/invoice-payment-link.service';
import InvoicePaymentLinkItem from '@/domain/billing/entity/invoice-payment-link/invoice-payment-link-item';
import PaymentLinkList from './billing-info-content-payment-link-list.component.vue';
import PaymentLinkDialog from './billing-info-content-payment-link-create.component.vue';

@Component({
  components: { PaymentLinkList, PaymentLinkDialog },
})
export default class BillingInfoContentPaymentLink extends Vue {
  @Prop({ type: String, required: true })
  invoiceId!: string;

  generatedLinks: InvoicePaymentLinkItem[] = [];

  showPaymentLinkDialog: boolean = false;

  loadingPaymentLinks: boolean = false;

  showCopySuccessful: boolean = false;

  newLinkCreated(newLink: InvoicePaymentLinkItem): void {
    this.generatedLinks.unshift(newLink);
  }

  loadPaymentLinks(): void {
    this.loadingPaymentLinks = true;
    InvoicePaymentLinkService.getInvoicePaymentLinks(this.invoiceId, 'createdDate,desc')
      .then((generatedLinks: InvoicePaymentLinkItem[]) => {
        this.generatedLinks = generatedLinks;
      }).catch(VbSnackbarService.handleHttpError)
      .finally(() => this.loadingPaymentLinks = false);
  }

  showSnackbar(): void {
    this.showCopySuccessful = true;
  }

  openPaymentLinkDialog(): void {
    this.showPaymentLinkDialog = true;
  }

  created(): void {
    this.loadPaymentLinks();
  }
}
